import { ActionTree, GetterTree, Module, MutationTree } from "vuex";
import { IIDAStore } from "../types";
import store from "../../store";
import { StoreCache } from "../storeCache";
import { ICypressState } from "./types";
import { cypressService } from "@/services/Cypress.service";

export const getInitialState = (): ICypressState => {
  return {
    storeCache: new StoreCache()
  };
};

const namespaced = true;

export const getters: GetterTree<ICypressState, IIDAStore> = {};

export const actions: ActionTree<ICypressState, IIDAStore> = {
  deleteAllTestDuties({ commit }) {
    return new Promise((resolve, reject) => {
      cypressService
        .deleteAllTestDuties()
        .then(() => {
          store.dispatch("duties/reset");
          resolve(null);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  deleteAllTestEvents({ commit }) {
    return new Promise((resolve, reject) => {
      cypressService
        .deleteAllTestEvents()
        .then(() => {
          store.dispatch("events/reset");
          resolve(null);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
};

export const mutations: MutationTree<ICypressState> = {};

export const cypressStoreModule: Module<ICypressState, IIDAStore> = {
  namespaced: namespaced,
  state: getInitialState(),
  getters: getters,
  actions: actions,
  mutations: mutations
};
